import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import axios from 'axios';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

const app = createApp(App)
// app.config.globalProperties.$unsplash = unsplash;
app.config.globalProperties.$axios = axios;
app.use(router).use(ElementPlus,{locale:zhCn}).mount('#app')